<template>
  <div class="login">
    <div class="login-con">
      <div class="login-top">
        <a class="login-top-link" href="https://yj.360.cn/">
          <img
            alt
            class="login-top-icon"
            src="https://p4.ssl.qhimg.com/t01cea0cfb86740359c.png?v4.21"
          />
          <span class="login-top-title">易讲教室直播</span>
        </a>
      </div>
      <div class="login-center">
        <img
          class="login-logo"
          src="https://p5.ssl.qhimg.com/t01a8b633c1204e580a.png"
        />
        <div class="login-panel">
          <p class="login-title">易讲学生端</p>
          <div class="login-board">
            <p class="login-board-title">360账号登录</p>
          </div>
        </div>
      </div>
    </div>
    <p class="copyright">
      Copyright©2026 360.CN All Rights Reserved 360互联网安全中心
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010502062738" rel="noreferrer" target="_blank">京公网安备11010502062738号</a>
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">京ICP证080047号[京ICP备08010314号-6]</a>
    </p>
  </div>
</template>

<script>
import global from "../utils/Global";
export default {
  name: "Login",
  data() {
    return {
      userInfo: global.defaultUserInfo,
      loginRules: {
        user_name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        pwd: [{ required: true, message: "请输入密码", trigger: "blur" }]
      }
    };
  },
  mounted() {
    var ua = navigator.userAgent;
    var mobile = !!ua.match(/AppleWebKit.*Mobile.*/);
    if (mobile) {
      that.$router.push("mlogin");
      return;
    }
    var that = this;
    var to_ = this.$route.params.to;
    QHPass.signIn($(".login-board"), function(e) {
      console.log("login success", e);
      QHPass.getUserInfo(
        function(data) {
          global.userInfo = data;
          console.log("userinfo jumping", data);
          if (to_) {
            that.$router.push(to_that);
          } else {
            if (mobile) {
              that.$router.push("mdevice");
            } else {
              that.$router.push("device");
            }
          }
        },
        function(err) {
          global.userInfo = null;
          console.log("userinfo error", err);
        }
      );
    });
    // 测试
    // let data = {
    //   qid: "2697699090",
    //   userName: "360U2697699090",
    //   nickName: "\u5fc3\u5ff5yy",
    //   mobile: "18245481145",
    //   type: "formal",
    //   src: "pcw_monitorzyun"
    // };
    // global.userInfo = data;
    // that.$router.push("device");
  },
  methods: {
    login() {}
  }
};
</script>

<style scoped>
body,
html {
  position: relative;
  width: 100%;
  height: 100%;
}
.login {
  position: relative;
  text-align: center;
  width: 100%;
  height: 100%;
  min-height: 100vh;
}
.login-logo {
  /* width: 758px;
  height: 622px; */
  width: 500px;
  height: 548px;
  background: #0495fc;
  padding: 80px 20px;
  border-radius: 8px 0 0 8px;
}
.login-center {
  /* width: 1280px; */
  height: 622px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.login-con {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  padding-bottom: 48px;
  box-sizing: border-box;
  background: #f5f5f5;
  /* background: #0495fc;
  background: -moz-linear-gradient(left, #0495fc 0%, #2a4be3 100%);
  background: -webkit-gradient(
    linear,
    left top,
    right bottom,
    color-stop(0%, #0495fc),
    color-stop(100%, #2a4be3)
  );
  background: -webkit-linear-gradient(left, #0495fc 0%, #2a4be3 100%);
  background: -o-linear-gradient(left, #0495fc 0%, #2a4be3 100%);
  background: -ms-linear-gradient(left, #0495fc 0%, #2a4be3 100%);
  background: linear-gradient(to right, #0495fc 0%, #2a4be3 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#0495fc', endColorstr='#2a4be3',GradientType=0 ); */
}
.login-top {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 56px;
  background: #fff;
}
.login-top-link {
  float: left;
  margin: 8px 0 0 40px;
}
.login-top-icon {
  width: 40px;
  height: 40px;
}
.login-top-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  line-height: 1;
  vertical-align: middle;
  margin-left: 5px;
}
.login-panel {
  width: 420px;
  height: 550px;
  background: #fff;
  position: relative;
  border-radius: 8px;
  padding-bottom: 30px;
}
.login-title {
  font-size: 32px;
  font-weight: bold;
  /* line-height: 120px;
  padding: 0; */
  margin: 0;
  line-height: 1;
  padding: 40px 0 20px 0;
}
.login-board {
  width: 370px;
  /* box-shadow: 0 0 16px 2px rgba(0, 0, 0, 0.1); */
  margin: -20px auto 0;
}
.copyright {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 16px;
  margin: 0;
  padding: 0 16px;
  font-size: 12px;
  color: #999;
  line-height: 20px;
  text-align: center;
}
.copyright a {
  color: #999;
  text-decoration: none;
}
.copyright a:hover {
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/page/login.vue